const getters = {
  orderDetail: state => state.userInfo, // 订单详情
  attendanceTimes: state => state.attendanceTimes, // 学生考勤次数
  listSignAndTally: state => state.listSignAndTally // 退款商品列表
};

export default getters;
